import { useSelector } from 'react-redux';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';

export const useHrisCustomFieldsFlag = (): boolean => {
  // Same selector/shape as RunPayroll/Grid/Filters.tsx uses for features?.hrisCustomFields:
  // const features = useSelector(loggedInUserSelectors.features);
  // const isHrisCustomFieldsEnabled = Boolean(features?.hrisCustomFields);
  const features = useSelector(loggedInUserSelectors.features);
  return Boolean(features?.hrisCustomFields);
};
